import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import api from '../api/client';
import { useAuth } from '../context/AuthContext';
import { Spinner, ErrorBox, Progress, DataTable, num, money } from '../components/ui';
export default function Programmes() {
  const { can } = useAuth();
  const nav = useNavigate();
  const [rows, setRows] = useState(null); const [err, setErr] = useState(null);
  const load = () => api.get('/programmes').then(r=>setRows(r.data)).catch(setErr);
  useEffect(() => { load(); }, []);
  useEffect(() => { const h=()=>load(); window.addEventListener('bsp2-prog-change',h); return ()=>window.removeEventListener('bsp2-prog-change',h); }, []);
  if (err) return <ErrorBox error={err} />;
  if (!rows) return <Spinner />;
  return <>
    <div className="phead"><h1>Programmes</h1><div style={{display:'flex',gap:10,alignItems:'center'}}><span className="muted">{rows.length} programmes</span>{can('programme.create') && <button className="primary" onClick={()=>nav('/programmes/new')}>+ New programme</button>}</div></div>
    <div className="panel"><DataTable rows={rows} columns={[
      { key:'programme_name', label:'Programme', render:(v,r)=><Link to={`/programmes/${r.programme_id}`}>{v}</Link> },
      { key:'programme_type', label:'Type', render:v=><span className={`badge ${v}`}>{v}</span> },
      { key:'client_name', label:'Client' },
      { key:'contractor_name', label:'Main contractor' },
      { key:'project_count', label:'Projects' },
      { key:'building_count', label:'Total buildings', render:num },
      { key:'hrb_buildings', label:'HRB', render:num },
      { key:'lrb_buildings', label:'LRB', render:num },
      { key:'avg_progress', label:'Progress', render:v=><Progress value={v}/> },
      { key:'delayed_substages', label:'Delayed', render:num },
      { key:'projects_at_risk', label:'At risk', render:(v)=>Number(v)>0
          ? <span className="badge risk-Atrisk">{num(v)}</span> : <span className="muted">—</span> },
      { key:'budget_amount', label:'Budget', render:money },
      { key:'total_spent', label:'Spent', render:money }
    ]}/></div>
  </>;
}
